import CategoryInstance from './CategoryInstance.component';

export default CategoryInstance;